module.exports = __webpack_public_path__ + "img/item-3.12b20358.png";